import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { Form, Input } from '@engloba-tech/englobity';
import { NAME_SPACE } from 'i18n';
import { isSkeletonLoading } from 'shared';
import { useOperatorForm } from './useOperatorForm';
import { useFormOperatorStyles } from './formOperator.styles';

export function FormOperator({ formRef, onSubmit, operator, errors, onChangeInput }) {
  const { t } = useTranslation(NAME_SPACE.OPERATORS);
  const classes = useFormOperatorStyles();
  const { operatorInputs, handleChange } = useOperatorForm(operator, onChangeInput);

  function handleSubmit() {
    onSubmit(operatorInputs);
  }

  return (
    <Form
      className={classes.formOperator}
      errors={errors}
      elementRef={formRef}
      onSubmit={handleSubmit}
      autoComplete="off"
    >
      <Grid container spacing={3}>
        <Grid sm={12} item>
          <Input
            isLoading={isSkeletonLoading(operatorInputs.name)}
            required
            name={t('properties.name')}
            label={t('properties.name')}
            variant="outlined"
            value={operatorInputs.name || ''}
            onChange={handleChange('name')}
            inputProps={{ 'aria-label': t('properties.name') }}
            validators={['required', 'maxStringLength:255']}
            errorMessages={[t('validations.required'), t('common:validations.maxStringLength', { length: 255 })]}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

FormOperator.propTypes = {
  formRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  onSubmit: PropTypes.func,
  errors: PropTypes.shape({
    message: PropTypes.string,
    detail: PropTypes.string
  }),
  operator: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  onChangeInput: PropTypes.func
};
